import { useEffect, useState, useCallback } from "react";
import CustomSnackbar from "../../Sections/Common/snackBar";
import { getLogoutOtpTime } from "../../Actions/common";
import { DEFAULT_LOGOUT_TIME_IN_MINUTE } from "../../config";

const events = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress",
];

const AppLogout = ({ children }) => {
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const LOGOUT_TIME = localStorage.getItem("GLOBAL_SETTING")
        ? getLogoutOtpTime()
        : DEFAULT_LOGOUT_TIME_IN_MINUTE; // Set your desired items per page

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const logOutTime = parseInt(LOGOUT_TIME) * 60 * 1000;
    const logoutAction = useCallback(() => {
        setSnackbar({
            open: true,
            message:
                "Your session has expired due to inactivity. Please log in again.",
            severity: "success",
        });
        localStorage.clear();
        localStorage.removeItem("token");
        localStorage.removeItem("GLOBAL_SETTING");
        localStorage.removeItem("userData");
        window.location.pathname = "/login";
    }, []);

    useEffect(() => {
        let timer; 

        const resetTimer = () => {
            if (timer) clearTimeout(timer);
        };

        const handleLogoutTimer = () => {
            timer = setTimeout(() => {
                resetTimer();
                events.forEach((item) => {
                    window.removeEventListener(item, handleActivity);
                });
                logoutAction();
            }, logOutTime);
        };

        const handleActivity = () => {
            resetTimer();
            handleLogoutTimer();
        };

        // Add event listeners
        events.forEach((item) => {
            window.addEventListener(item, handleActivity);
        });

        // Start the initial timer
        handleLogoutTimer();

        // Cleanup function
        return () => {
            resetTimer();
            events.forEach((item) => {
                window.removeEventListener(item, handleActivity);
            });
        };
    }, [logOutTime, logoutAction]);

    return (
        <>
            {children}
            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};

export default AppLogout;
